<template>
  <div>
    <inputbox
      name="from"
      :stacked="true"
      label="From"
      v-model="from"
    ></inputbox>
    <inputbox name="to" :stacked="true" label="To" v-model="to"></inputbox>
    <button class="btn btn-block btn-primary" v-on:click.prevent="getRoute">
      Get Route
    </button>

    <div class="map-section gutter-top">
      <div id="map"></div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    step: Object
  },

  data() {
    return {
      from: null,
      to: null,
      center: {
        lat: 51.507,
        lng: 0.127
      },
      start: {},
      end: {}
    };
  },

  mounted() {
    window.GoogleMapsLoader.load(google => {
      window.directionsDisplay = new google.maps.DirectionsRenderer();
      window.directionService = new google.maps.DirectionsService();
      let london = new google.maps.LatLng(51.507, 0.127);

      let options = {
        center: london,
        zoom: 14
      };

      window.map = new google.maps.Map(document.getElementById('map'), options);
      window.directionsDisplay.setMap(window.map);
    });
  },

  methods: {
    getRoute() {
      if (this.from && this.to) {
        let request = {
          origin: this.from,
          destination: this.to,
          travelMode: 'DRIVING'
        };

        window.directionService.route(request, (result, status) => {
          if (status == 'OK') {
            window.directionsDisplay.setDirections(result);
            this.start.location = result.routes[0].legs[0].start_address;
            this.start.latitude = result.routes[0].legs[0].start_location.lat();
            this.start.longitude = result.routes[0].legs[0].start_location.lng();
            this.end.location = result.routes[0].legs[0].end_address;
            this.end.latitude = result.routes[0].legs[0].end_location.lat();
            this.end.longitude = result.routes[0].legs[0].end_location.lng();
            this.$emit('set-route', {
              start_location: this.start.location,
              start_latitude: this.start.latitude,
              start_longitude: this.start.longitude,
              end_location: this.end.location,
              end_latitude: this.end.latitude,
              end_longitude: this.end.longitude
            });
          }
        });
      }
    }
  }
};
</script>
